<ng-container *ngIf="showCustomThankYou" [ngTemplateOutlet]="thankYouTemplate"></ng-container>

<div class="questionnaire-shell" *ngIf="!showCustomThankYou" [ngClass]="setDynamicClass()">
  <header class="mood-header">
    <img [src]="moodLogo()" [alt]="mood.moodName" />
    <span class="mood-name">{{ getMoodTranslationKey() | translate }}</span>
  </header>

  <div class="content-area">
    <section class="questionnaire-body" *ngIf="!formSubmitted" [@fadePanelTransition]>
      <article class="question-card" *ngIf="currentQuestion" [@springContentTransition]>
        <h2 class="question-title">{{ currentQuestion.questionText }}</h2>

        <div class="answers-list">
          <button
            *ngFor="let answer of currentQuestion.answers"
            class="answer-option"
            [ngClass]="setColor()"
            type="button"
            (click)="answerSelected(answer.id)"
          >
            {{ answer.answerText }}
          </button>

          <!-- Text feedback (other / free-text) — commented out until UX is decided
          <button class="answer-option" [ngClass]="setColor()" type="button" (click)="displayTextArea()">
            {{ 'feedback_other' | translate }}
          </button>
          -->
        </div>
      </article>

      <!-- Textarea article — commented out until text feedback UX is decided
      <article class="question-card" *ngIf="currentQuestion && showTextArea" [@aniHeightTransition]>
        <h2 class="question-title">{{ currentQuestion.questionText }}</h2>
        <textarea #textarea (keyup)="onTextareaChange()"></textarea>
        <button class="answer-option" [ngClass]="setColor()" type="button" (click)="answerSelected(-1)">
          {{ 'feedback_sendIn' | translate }}
        </button>
      </article>
      -->

      <nav class="question-indicator" *ngIf="questions.length > 1">
        <span
          *ngFor="let progressIndex of getProgressIndexes()"
          class="question-dot"
          [ngClass]="{ active: progressIndex <= currentIndex }"
        ></span>
      </nav>
    </section>

    <section *ngIf="formSubmitted" class="thank-you-note" [@fadePanelTransition]>
      <div class="thank-you-copy" [@springContentTransition]>
        <div class="thank-you">{{ 'feedback_thanks' | translate }}</div>
        <div>{{ 'feedback_haveNiceDay' | translate }}</div>
      </div>
    </section>
  </div>
</div>
